/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { delay } from 'redux-saga';
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { getProductGroupsApi } from 'redux/api/resellerApi';
import { getPropertyValuesApi } from 'redux/api/propertyApi';
import { setNotification, searchElementMatch, locales, EXTRA_TRANSLATION_TYPES, operatorTyping } from 'utils';
import * as TranslationActions from '../actions/translationActions';
import * as TranslationApi from '../api/translationApi';
import * as TranslationTypes from '../types/translationTypes';

const extraLocales = [...locales, 'de'];
const rebuildKey = 'R8Dm4bfdkDxu5e9vQKc_qb62T';

const getLayout = state => state.layout;
const getTranslations = state => state.translation;

// L O A D   T R A N S L A T I O N S
function* loadTranslationsSaga() {
    const layout = yield select(getLayout);
    const { locale } = layout;

    const translation = yield select(getTranslations);
    const { offset, limit, products, sort } = translation;

    try {
        const params = {
            offset,
            limit,
        };

        const hasName = translation.filters.name !== '';

        if (products.selected === 'PROPERTY_VALUE') {
            params.filter = { product: 'property', type: products.selected.toLowerCase() };
        } else if (products.selected === 'PROPERTY') {
            params.filter = { product: 'property', type: 'property' };
        } else if (EXTRA_TRANSLATION_TYPES.includes(products.selected)) {
            params.filter = { type: products.selected, product: 'translation' };
        } else if (products.selected) {
            params.filter = { product: products.selected.toLowerCase() };
        }

        const elementMatchName = searchElementMatch(translation.filters.name, locale);

        if ((hasName && products.selected === 'PROPERTY_VALUE') || (hasName && products.selected === 'PROPERTY')) {
            params.filter = JSON.stringify({
                ...params.filter,
                'name.translate': elementMatchName,
                product: 'property',
                type: products.selected.toLowerCase(),
            });
        } else if ((hasName && products.selected === 'PROPERTY') || (hasName && products.selected === 'CONFIGURATION')) {
            params.filter = JSON.stringify({
                ...params.filter,
                'name.translate': elementMatchName,
                product: products.selected.toLowerCase(),
            });
        } else if (hasName && products.selected === 'SEGMENT') {
            params.filter = JSON.stringify({
                ...params.filter,
                title: elementMatchName,
                product: products.selected.toLowerCase(),
            });
        } else if ((hasName && products.selected === 'PROMOTION') || (hasName && products.selected === 'DISCOUNT')) {
            params.filter = JSON.stringify({
                ...params.filter,
                'title.translate': elementMatchName,
                product: products.selected.toLowerCase(),
            });
        } else if (hasName && EXTRA_TRANSLATION_TYPES.includes(products.selected)) {
            params.filter = JSON.stringify({
                ...params.filter,
                tag: operatorTyping(translation.filters.name),
                product: 'translation',
            });
        } else if (hasName && products.selected) {
            params.filter = JSON.stringify({
                ...params.filter,
                name: elementMatchName,
                product: products.selected.toLowerCase(),
            });
        } else {
            params.filter = JSON.stringify(params.filter);
        }

        if (sort !== null) {
            if (sort.key === 'name') {
                params.sort_by = JSON.stringify({ unique_name: sort.type === 'asc' ? 1 : -1 });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sort.type === 'asc' ? 1 : -1 });
            }
        }

        const result = yield TranslationApi.getTranslationsApi(params);
        yield put(TranslationActions.loadTranslationsRes(result.data));
    } catch (e) {
        yield put(TranslationActions.loadTranslationsErr());
        console.log(e);
    }
}

export function* loadTranslationsWatcher() {
    yield takeLatest(TranslationTypes.LOAD_TRANSLATIONS, loadTranslationsSaga);
}
// L O A D   T R A N S L A T I O N S


// L O A D   E D I T A B L E   T R A N S L A T I O N S
function* loadEditableTranslationSaga(action) {
    const layout = yield select(getLayout);
    const translation = yield select(getTranslations);
    const { locale } = layout;
    const { products } = translation;

    try {
        let resultProperty = null;
        let paramsProperty = null;

        if (products.selected === 'PROPERTY_VALUE') {
            const [id] = action.id.split('_');
            paramsProperty = {
                filter: JSON.stringify({ product: 'property', type: products.selected.toLowerCase(), id }),
            };

            const resultPv = yield getPropertyValuesApi({ filter: JSON.stringify({ id: action.id }) });

            if (resultPv.status === 200) {
                const [pv] = resultPv.data.hits;
                yield put(TranslationActions.setSource(pv));
            }
        } else if (EXTRA_TRANSLATION_TYPES.includes(products.selected)) {
            paramsProperty = {
                filter: JSON.stringify({ type: products.selected, product: 'translation', id: action.id }),
            };
        } else if (products.selected) {
            paramsProperty = {
                filter: JSON.stringify({ product: products.selected.toLowerCase(), id: action.id }),
            };

            if (products.selected === 'PRODUCT-GROUP') {
                const resultPg = yield getProductGroupsApi({ filter: JSON.stringify({ id: action.id }) });

                if (resultPg.status === 200) {
                    const [pg] = resultPg.data.hits;
                    yield put(TranslationActions.setSource(pg));
                }
            }
        }

        if (paramsProperty) {
            resultProperty = yield TranslationApi.getTranslationsApi(paramsProperty);

            if (resultProperty !== null && resultProperty.data.hits.length > 0) {
                const [first] = resultProperty.data.hits;
                yield put(TranslationActions.loadEditableTranslationRes(first));
            } else {
                if (action.isEdit) {
                    yield put(push('/404'));
                }

                yield put(TranslationActions.loadEditableTranslationRes(null));
            }
        } else {
            yield put(TranslationActions.loadEditableTranslationRes(null));
            setNotification('error', locale, 'global.error', 'translation.notification.error');
        }
    } catch (e) {
        yield put(TranslationActions.loadEditableTranslationErr());
        setNotification('error', locale, 'global.error', 'translation.notification.error');
    }
}

export function* loadEditableTranslationWatcher() {
    yield takeLatest(TranslationTypes.LOAD_EDITABLE_TRANSLATION, loadEditableTranslationSaga);
}
// L O A D   E D I T A B L E   T R A N S L A T I O N S

// E D I T   T R A N S L A T I O N S
function* updateProductTranslateSaga(action) {
    const translation = yield select(getTranslations);
    const { products, edit } = translation;
    const { locale } = yield select(getLayout);

    const prop = products.selected.toLowerCase().replace('-', '_');
    const data = {
        [`${prop}_id`]: action.data[`${prop}_id`],
        reseller_id: action.data.reseller_id,
    };

    const dataPropertyValue = {
        [`${prop}_id`]: action.data[`${prop}_id`],
        reseller_id: action.data.reseller_id,
        property_id: edit.data.property,
    };

    const dataProductGroup = {
        product_group_id: action.data[`${prop}_id`],
        reseller_id: action.data.reseller_id,
    };

    const params = { bulk: [] };
    if (products.selected === 'PROPERTY_VALUE') {
        extraLocales.forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === TranslationTypes.EDIT_TRANSLATIONS)) {
                params.bulk.push({
                    ...action.data[lc],
                    ...dataPropertyValue,
                });
            }
        });
    } else if (products.selected === 'PRODUCT_GROUP') {
        extraLocales.forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === TranslationTypes.EDIT_TRANSLATIONS)) {
                params.bulk.push({
                    ...action.data[lc],
                    ...dataProductGroup,
                });
            }
        });
    } else {
        extraLocales.forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === TranslationTypes.EDIT_TRANSLATIONS)) {
                params.bulk.push({
                    ...action.data[lc],
                    ...data,
                });
            }
        });
    }

    if (products.selected === 'PROPERTY_VALUE') {
        const result = yield TranslationApi.editTranslationsApi(params, 'property/property-value');
        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }
    } else if (products.selected) {
        const result = yield TranslationApi.editTranslationsApi(params, products.selected.toLowerCase());
        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }
    }
}

function* editTranslationsSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'translation.notification.success';

    try {
        yield call(updateProductTranslateSaga, action);

        for (let i = 0; i < extraLocales.length; i += 1) {
            const lang = extraLocales[i];

            if (action.data[lang].slug) {
                const path = `/${lang}/${action.data[lang].slug}`;

                const rebuild = yield TranslationApi.rebuildApi({
                    key: rebuildKey,
                    path,
                });

                if (rebuild.status !== 200) {
                    console.warn('Error in rebuild the page');
                }
            }
        }

        yield put(push('/marketing/translations/'));

        yield put(TranslationActions.editTranslationsRes(false, true));
        yield delay(500);
        setNotification('success', locale, 'global.success', finalDescription);

        yield put(TranslationActions.editTranslationsRes(false, false));
    } catch (e) {
        yield put(TranslationActions.editTranslationsErr());
        setNotification('error', locale, 'global.error', 'translation.notification.error');
        console.log(e);
    }
}

export function* editTranslationsWatcher() {
    yield takeLatest(TranslationTypes.EDIT_TRANSLATIONS, editTranslationsSaga);
}
// E D I T   T R A N S L A T I O N S

// A D D   N E W   T R A N S L A T I O N S
function* addProductTranslateSaga(action) {
    try {
        const translation = yield select(getTranslations);
        const { products } = translation;
        const { locale } = yield select(getLayout);

        const data = {
            [`${products.selected.toLowerCase()}_id`]: action.data[`${products.selected.toLowerCase()}_id`],
            reseller_id: action.data.reseller_id,
        };

        const dataPropertyValue = {
            [`${products.selected.toLowerCase()}_id`]: action.data[`${products.selected.toLowerCase()}_id`],
            reseller_id: action.data.reseller_id,
            property_id: action.data.property,
        };

        const dataProductGroup = {
            product_group_id: action.data[`${products.selected.toLowerCase()}_id`],
            reseller_id: action.data.reseller_id,
        };

        const params = { bulk: [] };
        if (products.selected === 'PROPERTY_VALUE') {
            extraLocales.forEach((lc) => {
                if (lc !== 'en' || (lc === 'en' && action.type === TranslationTypes.ADD_NEW_TRANSLATION)) {
                    params.bulk.push({
                        ...action.data[lc],
                        ...dataPropertyValue,
                    });
                }
            });
        } else if (products.selected === 'PRODUCT-GROUP') {
            extraLocales.forEach((lc) => {
                if (lc !== 'en' || (lc === 'en' && action.type === TranslationTypes.ADD_NEW_TRANSLATION)) {
                    params.bulk.push({
                        ...action.data[lc],
                        ...dataProductGroup,
                    });
                }
            });
        } else {
            extraLocales.forEach((lc) => {
                if (lc !== 'en' || (lc === 'en' && action.type === TranslationTypes.ADD_NEW_TRANSLATION)) {
                    params.bulk.push({
                        ...action.data[lc],
                        ...data,
                    });
                }
            });
        }

        if (products.selected === 'PROPERTY_VALUE') {
            const result = yield TranslationApi.editTranslationsApi(params, 'property/property-value');
            if (result.status !== 202) {
                const error = yield result.json();
                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            }
        } else if (products.selected) {
            const result = yield TranslationApi.editTranslationsApi(params, products.selected.toLowerCase());
            if (result.status !== 202) {
                const error = yield result.json();
                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
                throw new Error('Error');
            }
        }
    } catch (e) {
        console.log(e);
    }
}

function* addNewTranslationSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'translation.notification.success';

    try {
        yield call(addProductTranslateSaga, action);

        yield put(push('/marketing/translations/'));

        yield put(TranslationActions.addNewTranslationRes(false, true));
        yield delay(1000);
        yield put(TranslationActions.addNewTranslationRes(false, false));

        setNotification('success', locale, 'global.success', finalDescription);
    } catch (e) {
        console.log(e);
        yield put(TranslationActions.addNewTranslationErr());
        setNotification('error', locale, 'global.error', 'translation.notification.error');
    }
}

export function* addNewTranslationWatcher() {
    yield takeLatest(TranslationTypes.ADD_NEW_TRANSLATION, addNewTranslationSaga);
}
// A D D   N E W   T R A N S L A T I O N S

// A D D   T R A N S L A T I O N   T A G
function* addTranslationTagSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield TranslationApi.addTranstaltionTagApi(action.data);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'translation.notification.addTranslationTag.success');
            yield put(TranslationActions.addTranslationTagRes());
            yield call(loadTranslationsSaga);
        } else {
            setNotification('error', locale, 'global.error', 'translation.notification.addTranslationTag.error');
            yield put(TranslationActions.addTranslationTagErr());
        }
    } catch (e) {
        console.log(e);
        yield put(TranslationActions.addTranslationTagErr());
    }
}
export function* addTranslationTagWatcher() {
    yield takeLatest(TranslationTypes.ADD_TRANSLATION_TAG, addTranslationTagSaga);
}
// A D D   T R A N S L A T I O N   T A G

// E D I T   T R A N S L A T I O N   T A G
function* editTranslationTagSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield TranslationApi.editTranstaltionTagApi(action.data);

        if (result.status === 202) {
            for (let i = 0; i < extraLocales.length; i += 1) {
                const lang = extraLocales[i];

                try {
                    let rebuild = null;
                    if (action.data.type === 'FRONT' && action.data.tag.includes('ui.')) {
                        rebuild = yield TranslationApi.rebuildApi({
                            key: rebuildKey,
                            path: action.data.tag.replace('ui.', ''),
                        });
                    } else {
                        const path = `/${lang}`;

                        rebuild = yield TranslationApi.rebuildApi({
                            key: rebuildKey,
                            path,
                        });
                    }

                    if (rebuild.status !== 200) {
                        console.warn('Error in rebuild the page');
                    }
                } catch (error) {
                    console.log('error', error);
                }
            }

            setNotification('success', locale, 'global.success', 'translation.notification.editTranslationTag.success');
            yield put(TranslationActions.editTranslationTagRes());
            yield call(loadTranslationsSaga);
        } else {
            setNotification('error', locale, 'global.error', 'translation.notification.editTranslationTag.error');
            yield put(TranslationActions.editTranslationTagErr());
        }
    } catch (e) {
        console.log(e);
        yield put(TranslationActions.editTranslationTagErr());
    }
}
export function* editTranslationTagWatcher() {
    yield takeLatest(TranslationTypes.EDIT_TRANSLATION_TAG, editTranslationTagSaga);
}
// E D I T   T R A N S L A T I O N   T A G
